import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

import router from './router/router'; // Importera routern

const app = createApp(App);
const pinia = createPinia()

// project setup
import {inithelpers} from "./helpers";
inithelpers(app);
import './style/main.scss'; // Import your custom Bootstrap styles

// setup based on settings
import settings from '@/settings/settings';

// languages
import { useTranslationsStore } from '@/dod/store/dtranslations';
const translationsStore = useTranslationsStore(pinia); // Use the globally registered store
translationsStore.languages = settings.default.languages;
translationsStore.translationFiles = settings.default.translations;

import { useWebSocketStore } from '@/dod/store/dwebsocket';
const wsStore = useWebSocketStore(pinia);
wsStore.keepid = settings?.default?.keep_websocketid ?? true;

// always setup dod
import {initdod} from "./dod/dimport";
initdod(app, pinia);

app.use(pinia)
app.use(router) // Använd routern   
app.mount("#app")